/**
 * Wortmarke von Præsto mit Herkunftszeile.
 *
 * Præsto ist ein Werkzeug von Digitalwart — das gehört auf jede Fläche, die
 * jemand von außen sieht: Anmeldung, Übersicht, Gast-Beitritt, Wartebereich.
 * Das Logo liegt als eigene Datei bei und wird nicht von digitalwart.de
 * nachgeladen; sonst hinge das Erscheinungsbild im Vortrag am Netz.
 */
export function Brandmark({
  size = 'large',
  byline = true,
}: {
  size?: 'large' | 'small'
  byline?: boolean
}): React.ReactElement {
  return (
    <span className={`brandmark brandmark-${size}`}>
      <span className="brandmark-name">Præsto</span>
      {byline && (
        <span className="brandmark-byline">
          <span>von</span>
          <img src="/brand/digitalwart.webp" alt="Digitalwart" width={420} height={49} />
        </span>
      )}
    </span>
  )
}
